var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDigitalAssets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "digital_assets") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_layer-group-solid",
    transform: "translate(-1431 -13)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3697",
    "data-name": "Rectangle 3697",
    width: 24,
    height: 24,
    transform: "translate(1431 13)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fillable-area",
    id: "layer-group-solid",
    d: "M40.174.207a1.967,1.967,0,0,1,1.652,0l7.685,3.551a.845.845,0,0,1,0,1.533L41.826,8.842a1.967,1.967,0,0,1-1.652,0L32.489,5.291a.845.845,0,0,1,0-1.533Zm7.467,7.187,1.87.865a.845.845,0,0,1,0,1.533l-7.685,3.551a1.967,1.967,0,0,1-1.652,0L32.489,9.791a.845.845,0,0,1,0-1.533l1.87-.865L39.7,9.862a3.1,3.1,0,0,0,2.595,0l5.344-2.468ZM42.3,14.362l5.344-2.468,1.87.865a.845.845,0,0,1,0,1.533l-7.685,3.551a1.967,1.967,0,0,1-1.652,0l-7.685-3.551a.845.845,0,0,1,0-1.533l1.87-.865L39.7,14.362A3.1,3.1,0,0,0,42.3,14.362Z",
    transform: "translate(1402 15.975)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalAssets);
export default __webpack_public_path__ + "static/media/digital_assets.5580139a4c07e6ce397b8ab188fcd50e.svg";
export { ForwardRef as ReactComponent };